import { generateTable } from '../../table/Table';
import { fetchUsage } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).equals('type', 'type').startsWith('source', 'source').startsWith('group', 'group').startsWith('name', 'name').end();

var dataSource = function dataSource(_ref) {
  var definitionId = _ref.definitionId,
      sourceName = _ref.sourceName,
      sourceGroup = _ref.sourceGroup,
      name = _ref.name,
      usageType = _ref.usageType;
  return {
    fn: fetchUsage,
    clientSide: clientSide,
    params: function params() {
      return [{
        definitionId: definitionId,
        sourceName: sourceName,
        sourceGroup: sourceGroup,
        name: name,
        usageType: usageType
      }];
    },
    transform: function transform(result) {
      return {
        data: result.usages
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'type',
      label: 'Type',
      type: 'text'
    }, {
      name: 'source',
      label: 'Source',
      type: 'text'
    }, {
      name: 'group',
      label: 'Group',
      type: 'text'
    }, {
      name: 'name',
      label: 'Name',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'type',
  title: 'Type',
  sortable: true
}, {
  value: 'source',
  title: 'Source',
  sortable: true
}, {
  value: 'group',
  title: 'Group',
  sortable: true
}, {
  value: 'name',
  title: 'Tree',
  sortable: true
}, {
  value: 'nodeCount',
  title: 'Usage',
  sortable: true
}, {
  value: 'updatedAt',
  title: 'Updated',
  sortable: true
}];
export var UsageTable = generateTable({
  tableOptions: ['definitionId', 'sourceName', 'sourceGroup', 'name', 'usageType'],
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
UsageTable.displayName = 'UsageTable';